module.exports = __webpack_public_path__ + "assets/images/01_0df99fca0464a8b3cced0068f76d4bee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/01.png
// module id = 113
// module chunks = 0